<app-page headline="Business Entities">
  <DataTable
    [datasource]="businessEntities"
    [columns]="businessEntitiesColumns"
    (rowClick)="handleRowClick($event)"
  >
    <div
      row-layout
      paddingLeft="md"
      ngProjectAs="data-table-header"
      justifyContent="space-between"
      alignItems="center"
    >
      <div row-layout gap="md">
        <Text role="headline-medium" color="on-background-variant"
          >Locations</Text
        >
        <app-download-button
          [blobObservable]="businessEntityService.downloadBusinessEntities()"
          label="Download Business Entities (xlsx)"
          downloadFileName="ATB_Business_Entities"
        />
      </div>
      <oui-data-search
        label="Search:"
        labelTextRole="headline-small"
        [datasource]="businessEntities"
        [fields]="['code', 'name']"
      />
    </div>
  </DataTable>
</app-page>

<Dialog [show]="showDialog()" (showing)="showDialog.set($event)">
  <DialogHeader>Details</DialogHeader>
  <div stack-layout padding="md" gap="sm" [width]="300">
    <app-display-value label="Code">
      {{ selectedBusinessEntity()?.code }}
    </app-display-value>
    <app-display-value label="Name">
      {{ selectedBusinessEntity()?.name }}
    </app-display-value>
  </div>
</Dialog>
